

























































import Vue from 'vue';
import Component from 'vue-class-component';
import Loader from '@/components/loader/Loader.vue';
import { UserModule } from '@/store/modules/User';
import { AppModule } from '@/store/modules/App';

@Component({
	components: {
		loader: Loader
	}
})
export default class App extends Vue {
	private showContent = AppModule.showContent;

	get loggedIn() {
		return UserModule.loggedIn;
	}

	get surveyFinished() {
		return UserModule.surveyFinished;
	}
}
